module.exports = __webpack_public_path__ + "static/media/PM40.532ba8f3.png";